import imageKokugo from "@/styles/img/common/img_kokugo.svg"
import imageChiri from "@/styles/img/common/img_chiri.svg"
import imageRekishi from "@/styles/img/common/img_rekishi.svg"
import imageKomin from "@/styles/img/common/img_komin.svg"
import imageSugaku from "@/styles/img/common/img_sugaku.svg"
import imageRika from "@/styles/img/common/img_rika.svg"
import imageEigo from "@/styles/img/common/img_eigo.svg"
import imageBadge_0 from "@/styles/img/work/img_badge_0.png"
import imageBadge_1 from "@/styles/img/work/img_badge_1.png"
import imageBadge_2 from "@/styles/img/work/img_badge_2.png"
import imageBadge_3 from "@/styles/img/work/img_badge_3.png"
import imageBadge_0_2x from "@/styles/img/work/img_badge_0@2x.png"
import imageBadge_1_2x from "@/styles/img/work/img_badge_1@2x.png"
import imageBadge_2_2x from "@/styles/img/work/img_badge_2@2x.png"
import imageBadge_3_2x from "@/styles/img/work/img_badge_3@2x.png"

const SUBJECTFIELD_ID_IMAGE_MAP: { [value: string]: any } = {
  "kokugo": imageKokugo,
  "chiri": imageChiri,
  "rekishi": imageRekishi,
  "komin": imageKomin,
  "sugaku": imageSugaku,
  "rika": imageRika,
  "eigo": imageEigo
}

const BADGE_IMAGE_MAP: { [value: number]: any } = {
  0: imageBadge_0,
  1: imageBadge_1,
  2: imageBadge_2,
  3: imageBadge_3,
}

const BADGE_IMAGE_2X_MAP: { [value: number]: any } = {
  0: imageBadge_0_2x,
  1: imageBadge_1_2x,
  2: imageBadge_2_2x,
  3: imageBadge_3_2x,
}

export {
  SUBJECTFIELD_ID_IMAGE_MAP,
  BADGE_IMAGE_MAP,
  BADGE_IMAGE_2X_MAP,
}
